import { AsyncSelect } from "@caelor/ui";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const findUsersByName = async (query) => {
  const cql = query
    ? `/rest/api/search/user?cql=user.fullname~"${query}"*`
    : `/rest/api/search/user?cql=user.fullname~"*"*`;
  try {
    return await window.AP.request(cql);
  } catch (e) {
    console.log("cant fetch users");
    console.log(e);
    return null;
  }
};

const mapUser = (user) => {
  return {
    avatarUrl: `${window.AP._hostOrigin}${user.profilePicture.path}`,
    id: user.accountId,
    name: user.publicName,
    type: "user",
    label: user.publicName,
    value: user.accountId,
  };
};

const PeoplePicker = ({ selectedPeople = [], onSelect = () => {} }) => {
  const ref = useRef();
  const { t } = useTranslation();

  const loadOptions = async (query) => {
    try {
      const users = await findUsersByName(query);
      const { results } = JSON.parse(users.body);
      const atlassianUsers = results
        .filter(({ user }) => user.accountType === "atlassian")
        .filter(({ user }) => {
          if (!selectedPeople.length) return true;
          return !selectedPeople.find(
            ({ accountId }) => accountId === user.accountId
          );
        })
        .map(({ user }) => mapUser(user));
      return atlassianUsers;
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    if (ref?.current?.focus) {
      ref.current.focus();
    }
  }, [ref]);

  return (
    <AsyncSelect
      ref={ref}
      value={[]}
      isSearchable
      controlShouldRenderValue={false}
      closeMenuOnSelect={false}
      placeholder={t("select-people")}
      onChange={(option) => {
        onSelect(option);
      }}
      loadOptions={loadOptions}
    />
  );
};

export default PeoplePicker;
